"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var canUseDOM_1 = __importDefault(require("@seaweb/coral/utils/canUseDOM"));
function useCompoundBlur(cb) {
    var elsRef = react_1.useRef({});
    var cancelRafs = react_1.useRef([]);
    react_1.useEffect(function () { return function () { return cancelRafs.current.forEach(function (cancel) { return cancel(); }); }; }, []);
    return {
        register: function (key, element) {
            elsRef.current[key] = element;
            return function () {
                delete elsRef.current[key];
            };
        },
        handleCompoundBlur: function (e) {
            var defaultPrevented = e.defaultPrevented;
            var rafId = setTimeout(function () {
                if (defaultPrevented || !canUseDOM_1.default())
                    return;
                if (!Object.values(elsRef.current).some(function (el) { return el && el.contains(document.activeElement); })) {
                    cb(e);
                }
            });
            var cancel = function () {
                clearTimeout(rafId);
                cancelRafs.current = cancelRafs.current.filter(function (c) { return c !== cancel; });
            };
            cancelRafs.current.push(cancel);
            return cancel;
        },
    };
}
exports.default = useCompoundBlur;
